<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-4 md:mb-8 max-w-3xl">
      <h1 class="text-xl md:text-3xl font-bold">
        <Link class="text-primary-400 hover:text-primary-600">Passwort ändern</Link>
        <span class="text-primary-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap flex-col p-5 md:p-8 text-sm md:text-base">
          <text-input v-model="form.old_password" :error="form.errors.first_name" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.old_password')" />
          <text-input v-model="form.new_password" :error="form.errors.first_name" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.new_password')" />
          <text-input v-model="form.new_password_repeat" :error="form.errors.first_name" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.new_password_repeat')" />
        </div>
        <div class="flex flex-col-reverse md:flex-row items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-primary w-full md:w-auto block md:flex text-center ml-auto" type="submit">{{ __('profile.update')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
  },

  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        old_password: '',
        new_password: '',
        new_password_repeat: '',
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
